/* eslint-disable */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
    Wrap, Grid, Item, Overlay, Icon,
} from './styles';

const Benefits = ({ className, benefitList }) => {
    const [activeIndex, setActiveIndex] = useState(null);
    const [shouldShowOverlay, toggleShowOverlay] = useState(false);

    const openOverlay = (index) => {
        setActiveIndex(index);
        toggleShowOverlay(true);
    };

    return (
        <Wrap className={className}>
            <Grid shouldShow={!shouldShowOverlay}>
                {benefitList.map((item, index) => {
                    const { title, image: { url } = {} } = item;
                    return (
                        <Item
                            icon={<Icon src={url} />}
                            title={title}
                            key={title}
                            openOverlay={() => openOverlay(index)}
                        />
                    );
                })}
            </Grid>
            <Overlay
                shouldShow={shouldShowOverlay}
                activeIndex={activeIndex}
                benefitList={benefitList}
                closeOverlay={() => toggleShowOverlay(false)}
            />
        </Wrap>
    );
};

Benefits.propTypes = {
    className: PropTypes.string,
    benefitList: PropTypes.arrayOf(PropTypes.object),
};

Benefits.defaultProps = {
    className: '',
    benefitList: [],
};

export default Benefits;
